import { COMPANY_CONTACTS } from "../constants/contacts";

/**
 * Tenant contacts from storefront config. Do not fall back to host SV City
 * numbers when a tenant is resolved (ADR-0001 / #153).
 */
export function resolveBrandContacts(brand) {
  const tenantId = brand?.tenant?.id;
  const c = brand?.contacts || brand?.branding?.contacts || {};
  if (tenantId) {
    const phones = Array.isArray(c.phones) ? c.phones.filter((p) => p && (p.tel || p.display)) : [];
    return {
      email: c.email || brand.supportEmail || "",
      phones,
      primaryPhone: c.primaryPhone || phones[0]?.display || "",
      primaryPhoneTel: c.primaryPhoneTel || phones[0]?.tel || "",
      telegram: c.telegram || "",
      whatsapp: c.whatsapp || "",
      facebook: c.facebook || "",
      instagram: c.instagram || "",
    };
  }
  return COMPANY_CONTACTS;
}
